
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M20.5 9.263c.43-.13.5-.388.5-.688 0-.3-.203-.575-.6-.575h-1.9c-1.3-2-2-3-4.1-3H9.6C7.5 5 6.8 6 5.5 8H3.6c-.397 0-.6.275-.6.575 0 .3.07.558.5.688l1.4.294L3 11v6.5a1 1 0 001 1h1.5a1 1 0 001-1V17h11v.5a1 1 0 001 1H20a1 1 0 001-1V11l-1.9-1.443 1.4-.294zM7.5 14h-2A1.5 1.5 0 014 12.5V12h2a1.5 1.5 0 011.5 1.5v.5zm4.25-.5c0 .276-.474.5-.75.5H9.5c-.63 0-1.5-.5-1.5-1.5 0-.3.4-.5.7-.5H11c.276 0 .75.224.75.5v1zM6.5 9c.57-1.563 1.234-3 2.8-3h5.4c1.565 0 2.229 1.438 2.8 3h-11zm8 5H13c-.276 0-.75-.224-.75-.5v-1c0-.276.474-.5.75-.5h2.3c.3 0 .7.2.7.5 0 1-.87 1.5-1.5 1.5zm5.5-2v.5a1.5 1.5 0 01-1.5 1.5h-2v-.5A1.5 1.5 0 0118 12h2z","fill":"currentColor"}})])
          )
        }
      }
    